import type {
  CreateGlossaryEntryServiceConfig,
  DeleteGlossaryEntryServiceConfig,
  GetGlossaryEntryServiceConfig,
  GlossaryListServiceConfig,
  UpdateGlossaryEntryServiceConfig,
} from '@/services/httpServices/GlossaryServices/types';

import { createQueryKey } from './queryKeyUtils';

export function glossaryListKeys(params?: GlossaryListServiceConfig) {
  return createQueryKey(['glossaryList'], params);
}

export function glossaryEntryByIdKeys(params?:
  | GetGlossaryEntryServiceConfig
  | DeleteGlossaryEntryServiceConfig
  | UpdateGlossaryEntryServiceConfig
  | CreateGlossaryEntryServiceConfig) {
  return createQueryKey(['glossaryEntryById'], params);
}
